module.exports = __webpack_public_path__ + "static/media/kaple-srdce.a8d28907.jpg";